import { useSuspenseQuery } from "@tanstack/react-query";

import { QUERY_KEYS } from "@api/queryKeys";
import useArticleSection from "@FillInTableContainer/hooks/useArticleSection";
import { getPressIdFromURL } from "@utils/getStateFromURL";

import { dealTypeCategoryApis } from "./dealTypeCategory.service";

const NON_DEAL_DEAL_TYPE_CATEGORY = {
  data: {
    dealTypeCategory: "",
  },
  code: 200,
  message: "Not a Deals or Deal LA&SC article",
};

export const useDealTypeCategoryQuery = (
  draftArticleId = Number(getPressIdFromURL()),
) => {
  const articleSectionByClassification = useArticleSection();
  const isDealSection = ["Deals", "Deal LA&SC"].includes(
    articleSectionByClassification,
  );

  return useSuspenseQuery({
    queryKey: [QUERY_KEYS.dealTypeCategory, draftArticleId],
    queryFn: () => {
      if (!isDealSection) return NON_DEAL_DEAL_TYPE_CATEGORY;
      return dealTypeCategoryApis.get(draftArticleId);
    },
    select: ({ data }) => data.dealTypeCategory,
    // NOTE: Deals 외 섹션은 dealTypeCategory가 필요 없으므로 initialData로 suspend 자체를 막는다.
    ...(isDealSection ? {} : { initialData: NON_DEAL_DEAL_TYPE_CATEGORY }),
    // NOTE: 캐시는 유지하되 staleTime: 0으로 mount마다 백그라운드 refetch하여 최신성은 보장한다.
    staleTime: 0,
  });
};
